"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _get = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var vm = require("vm");

var whatwgEncoding = require("whatwg-encoding");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var reflectURLAttribute = require("../../utils").reflectURLAttribute;

var resourceLoader = require("../../browser/resource-loader");

var reportException = require("../helpers/runtime-script-errors");

var domSymbolTree = require("../helpers/internal-constants").domSymbolTree;

var nodeTypes = require("../node-type");

var jsMIMETypes = new Set(["application/ecmascript", "application/javascript", "application/x-ecmascript", "application/x-javascript", "text/ecmascript", "text/javascript", "text/javascript1.0", "text/javascript1.1", "text/javascript1.2", "text/javascript1.3", "text/javascript1.4", "text/javascript1.5", "text/jscript", "text/livescript", "text/x-ecmascript", "text/x-javascript"]);

var HTMLScriptElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLScriptElementImpl, _HTMLElementImpl);

  function HTMLScriptElementImpl() {
    _classCallCheck(this, HTMLScriptElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLScriptElementImpl).apply(this, arguments));
  }

  _createClass(HTMLScriptElementImpl, [{
    key: "_attach",
    value: function _attach() {
      _get(_getPrototypeOf(HTMLScriptElementImpl.prototype), "_attach", this).call(this);

      if (this.src) {
        resourceLoader.load(this, this.src, {
          defaultEncoding: whatwgEncoding.labelToName(this.getAttribute("charset")) || this._ownerDocument._encoding
        }, this._eval);
      } else if (this.text.trim().length > 0) {
        resourceLoader.enqueue(this, this._ownerDocument.URL, this._eval)(null, this.text);
      }
    }
  }, {
    key: "_attrModified",
    value: function _attrModified(name, value, oldValue) {
      _get(_getPrototypeOf(HTMLScriptElementImpl.prototype), "_attrModified", this).call(this, name, value, oldValue);

      if (this._attached && name === "src" && oldValue === null && value !== null) {
        resourceLoader.load(this, this.src, {
          defaultEncoding: whatwgEncoding.labelToName(this.getAttribute("charset")) || this._ownerDocument._encoding
        }, this._eval);
      }
    }
  }, {
    key: "_eval",
    value: function _eval(text, filename) {
      var typeString = this._getTypeString();

      if (this._ownerDocument.implementation._hasFeature("ProcessExternalResources", "script") && jsMIMETypes.has(typeString.toLowerCase())) {
        this._ownerDocument._writeAfterElement = this;
        processJavaScript(this, text, filename);
        delete this._ownerDocument._writeAfterElement;
      }
    }
  }, {
    key: "_getTypeString",
    value: function _getTypeString() {
      var typeAttr = this.getAttribute("type");
      var langAttr = this.getAttribute("language");

      if (typeAttr === "") {
        return "text/javascript";
      }

      if (typeAttr === null && langAttr === "") {
        return "text/javascript";
      }

      if (typeAttr === null && langAttr === null) {
        return "text/javascript";
      }

      if (typeAttr !== null) {
        return typeAttr.trim();
      }

      if (langAttr !== null) {
        return "text/" + langAttr;
      }

      return null;
    }
  }, {
    key: "text",
    get: function get() {
      var text = "";
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = domSymbolTree.childrenIterator(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          if (child.nodeType === nodeTypes.TEXT_NODE) {
            text += child.nodeValue;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return text;
    },
    set: function set(text) {
      this.textContent = text;
    }
  }, {
    key: "src",
    get: function get() {
      return reflectURLAttribute(this, "src");
    },
    set: function set(V) {
      this.setAttribute("src", V);
    }
  }]);

  return HTMLScriptElementImpl;
}(HTMLElementImpl);

function processJavaScript(element, code, filename) {
  var document = element.ownerDocument;
  var window = document && document._global;

  if (window) {
    document._currentScript = element;

    try {
      vm.runInContext(code, window, {
        filename: filename,
        displayErrors: false
      });
    } catch (e) {
      reportException(window, e, filename);
    } finally {
      document._currentScript = null;
    }
  }
}

module.exports = {
  implementation: HTMLScriptElementImpl
};